import {
  Button,
  Calendar,
  cn,
  FormControl,
  FormItem,
  FormMessage,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@racefront/shadcn-ui'
import { format, subYears } from 'date-fns'
import { CalendarIcon } from 'lucide-react'
import { ControllerRenderProps } from 'react-hook-form'
import { el, Locale, sv } from 'react-day-picker/locale' // Add more locales as needed

const eighteenYearsAgo = subYears(new Date(), 18)

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: ControllerRenderProps<any, any>
  isRequired?: boolean
  formater?: (val: Date) => string | Date
  hasError?: boolean
  placeholder?: React.ReactNode
  lang?: string
}

const localeMap: Record<string, Locale> = {
  sv: sv,
  el: el,
}

export function DateInput({ field, isRequired, formater, hasError, placeholder, lang }: Props) {
  const handleSelect = (...event: unknown[]) => {
    const day = event?.[0] as unknown as Date
    field.onChange(formater ? formater(day) : day)
  }

  return (
    <FormItem className="flex flex-col">
      {/* <FormLabel>{field.name}</FormLabel> */}
      <Popover>
        <PopoverTrigger>
          <FormControl>
            <Button
              type="button"
              variant={'outline'}
              className={cn(
                'w-full',
                !field.value && 'text-muted-foreground',
                hasError && 'border-destructive',
                'h-12',
              )}
            >
              {field.value ? format(field.value, 'PPP') : <span>{placeholder || 'Pick a date'}</span>}
              <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
            </Button>
          </FormControl>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            lang={lang}
            required={isRequired}
            mode="single"
            defaultMonth={field?.value ? new Date(field.value) : eighteenYearsAgo}
            selected={field?.value ? new Date(field.value) : eighteenYearsAgo}
            onSelect={handleSelect}
            disabled={(date) => date > new Date() || date < new Date('1900-01-01')}
            captionLayout="dropdown"
            locale={lang ? localeMap[lang] : undefined}
          />
        </PopoverContent>
      </Popover>
      {/* <FormDescription></FormDescription> */}
      <FormMessage />
    </FormItem>
  )
}
